export enum ACTIVITY_SALES_OFFER_METRIC_ENUM {
  SUMMARY = 'summary',
  OFFER_HISTOGRAM = 'offer-histogram',
  REACTIVE_CLIENTS = 'reactive-clients',
}

export enum PRODUCT_OFFER_METRIC_ENUM {
  SUMMARY = 'summary',
  TOP_PRODUCTS = 'top-products',
  TOP_CATEGORIES = 'top-categories',
  DISCOUNT_BUCKETS = 'discount-buckets',
  HISTOGRAM = 'product-offer-histogram',
}
